module.exports = __webpack_public_path__ + "img/post_box.72519cbd.svg";